import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import "./InstructionsDialog.scss";

const InstructionDialog = ({ open, onClose, instructions }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: "instruction-popup" }}
      maxWidth="md"
      disableEnforceFocus
      slotProps={{
        backdrop: {
          className: "custom-backdrop-instruction",
        },
      }}
    >
      <DialogActions className="instruction-actions">
        <IconButton className="close-button" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogActions>

      <DialogContent dividers className="instruction-content">
        <h1>Instructions</h1>
        {instructions.map((instruction, index) => (
          <p key={index}>{instruction}</p>
        ))}
      </DialogContent>
    </Dialog>
  );
};

export default InstructionDialog;
